module.exports = __webpack_public_path__ + "c2aef095b236d479ffd433dd87abd0ab.MP3";